import { render, staticRenderFns } from "./ClientSwitcherBox.vue?vue&type=template&id=16d47674&scoped=true"
import script from "./ClientSwitcherBox.vue?vue&type=script&lang=js"
export * from "./ClientSwitcherBox.vue?vue&type=script&lang=js"
import style0 from "./ClientSwitcherBox.vue?vue&type=style&index=0&id=16d47674&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16d47674",
  null
  
)

export default component.exports